import { render } from "./Leccion.vue?vue&type=template&id=31204a09"
import script from "./Leccion.vue?vue&type=script&lang=js"
export * from "./Leccion.vue?vue&type=script&lang=js"

import "./Leccion.vue?vue&type=style&index=0&id=31204a09&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__